/**
 * Renders text with inline `code` segments styled as <code> elements.
 *
 * When split() uses a capturing group, captured content is included in the result array.
 * Example: "Allow for `git`, `npm`".split(/`([^`]+)`/)
 *        → ["Allow for ", "git", ", ", "npm", ""]
 *           index 0 (text)  1 (code)  2 (text)  3 (code)  4 (text)
 * Captured groups always land on odd indices, so index % 2 === 1 identifies code.
 */
export function InlineCode({text, codeClassName}: {text: string; codeClassName?: string}) {
  const parts = text.split(/`([^`]+)`/)
  return (
    <>
      {parts.map((part, index) =>
        index % 2 === 1 ? (
          // eslint-disable-next-line @eslint-react/no-array-index-key
          <code key={`code-${index}-${part}`} className={codeClassName}>
            {part}
          </code>
        ) : (
          // eslint-disable-next-line @eslint-react/no-array-index-key
          <span key={`text-${index}-${part}`}>{part}</span>
        ),
      )}
    </>
  )
}
